export const NOUVELLE_SOUSCRIPTION_EXERCICE_FORM_NAME = "exercice";
export const NOUVELLE_SOUSCRIPTION_ACCEPT_TERMS_FORM_NAME = "acceptTerms";
export const NOUVELLE_SOUSCRIPTION_ROLE_SELECTED = "";
